import React from 'react';
import { useAtomCallback, useAtomValue } from '@exodus/headless-ui';
import { toAssetAtom, isLoadingAtom, toWalletAccountAtom } from '../../../atoms/index.js';
const ToWalletAccount = ({ Component, className, style, onPress, }) => {
    const isLoading = useAtomValue(isLoadingAtom);
    const toWalletAccount = useAtomValue(toWalletAccountAtom);
    const handlePress = useAtomCallback(async (get, set) => {
        const result = await onPress({
            side: 'to',
            assetName: get(toAssetAtom).name,
            currentWalletAccount: get(toWalletAccountAtom),
        });
        if (result)
            set(toWalletAccountAtom, result);
    }, [onPress]);
    if (Component) {
        return (React.createElement(Component, { walletAccount: toWalletAccount, loading: isLoading, className: className, style: style, onPress: handlePress }));
    }
    return null;
};
export default ToWalletAccount;
